import { UserContext } from "../Definitions/UserContext";
import { AsyncAjaxDelete, AsyncAjaxGet, AsyncAjaxPost, AsyncAjaxPut } from "./AsyncAjaxService";
import { ValidateToken } from "./BusinessData";

const BlogAPIEnum = {

    getPublicPosts: "blog/list",
    getAllPosts: "blog/list",
   
    deletePost: "blog/delete?blogId=",
    
    addTag: "blog/tag/add",
    listTags: "blog/tag",
    // editTag: "editTag",
    deleteTag: "blog/tag/delete?tagid=",
    
    addCategory: "blog/category/add",
    listCategories: "blog/category",
    // editCategory: "editCategory",
    deleteCategory: "blog/category/delete?categoryId=",

    createPostWithoutContent: "blog/add",
    editPostWithoutContent: "blog/edit",

    savePostContent: "blog/savecontent",
    publishPost:"blog/publish",

    blogEditorDetails: "blog/",

    updateCategoryByPost:"blog/changecategoryasync",
    updateTagsByPost:"blog/changetagasync",

    getAuthors:"blog/author",

    publishStyling:"blog/style/publish",
    saveStyling:"blog/style/save",
    getStyling:"blog/style",
    consumerDetails:"blog/publish/",
    
    archivePost:"blog/archive?blogId=",

    activateBlog:"blog/activate?blogId=",

    getBlogFromTag:"blog/publish/tag/",
    getBlogFromCategory:"blog/publish/category/"
}



const tempBID = "U2FsdGVkX18VnGJclOuAzXpZEBVblVf8d6C9-g3lARQ=";
const tempUserID = "U2FsdGVkX18VnGJclOuAzS5UDYRWHAGf9pQNpqIRfgE=";

async function AjPost(url:string,body:any,context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await AsyncAjaxPost(
        url,
        body,
        context.accessToken,
        onComplete,onError,
        // tempBID,
        // tempUserID
        context.businessId,
        context.encUserId
    );

}

 async function AjGet(url:string,context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await AsyncAjaxGet(
        url,
        context.accessToken,
        onComplete,onError,
        // tempBID,
        // tempUserID
        context.businessId,
        context.encUserId
    );

}

async function AjPut(url:string,body:any,context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await AsyncAjaxPut(
        url,
        context.accessToken,
        body,
        onComplete,onError,
        // tempBID,
        // tempUserID
        context.businessId,
        context.encUserId
    );

}

async function AjDelete(url:string,context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await AsyncAjaxDelete(
        url,
        context.accessToken,
        onComplete,onError,
        // tempBID,
        // tempUserID
        context.businessId,
        context.encUserId
    );

}


export async function CreateBlogPost(context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void,title:string = "New Post",slug:string = "",author:string = "",cats:string[] = [],tags:string[] = [],img:string="",status:number = 1){

    await ValidateToken(context);

    if(slug == ""){
        slug = title.replaceAll(" ","-").toLowerCase();
    }

    const body = {
        "Id": "0",
        "Title":title,
        "URLslug": slug,
        "Author" : author,
        "Category" : cats,
        "Tag" : tags,
        "ImageURL" : img,
        "Status" : status
    }

    const url = BlogAPIEnum.createPostWithoutContent;

    await AjPost(url,body,context,onComplete,onError);

}


export function GetPostInfoFromResponse(item:any):BlogPostInfo{

    let formattedDate:string = ""
    if(typeof item.strPublishDate!='undefined' && item.strPublishDate!="")
    {
        let date = new Date(item.strPublishDate+" UTC");
        formattedDate = new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }).format(date);
    }



    return {
        id:item.id,
        title:item.title,
        slug:item.urLslug,
        content:"",
        readTime:item.readTime,
        date:"",
        author:item.author,
        encAuthor: item.encAuthor,
        category: item.category,
        tags:item.tag,
        isArchive:item.isArchive??false,
        status:item.status,
        image:item.imageURL,
        titleTag:item.titleTag??item.title,
        metaDescription:item.metaDescription??"",
        publishDate:item.publishDate,
        publishDateStr:formattedDate,
    }
}

export async function ArchivePost(context:UserContext,postId:string,onComplete:(data:any)=>void,onError:(data:any)=>void){
    await ValidateToken(context);

    const url = BlogAPIEnum.archivePost+postId;
    AjDelete(url,context,onComplete,onError);

}
export async function ActivateBlogPost(context:UserContext,postId:string,onComplete:(data:any)=>void,onError:(data:any)=>void){
    await ValidateToken(context);

    const url = BlogAPIEnum.activateBlog+postId;
    AjPut(url,null,context,onComplete,onError);

}


export function GetPostInfoArrayFromResponse(data:any):BlogPostInfo[]{
    
    

    let posts:BlogPostInfo[] = [];

    let arr = data?.data?.data;

    if(!arr){
        return posts;
    }

    return arr.map((item:any)=>{

        return GetPostInfoFromResponse(item);

    });



}

export async function DuplicateBlogPost(
    newName:string,
  context: UserContext,
  postId: string,
  onComplete: (data: any) => void,
  onError: (data: any) => void
) {
  await ValidateToken(context);

  //1 load editor details for original post
  await LoadBlogEditorDetails(
    context,
    postId,
    (detailData: any) => {
      let blogData = detailData?.data?.data;

      if (!blogData) {
        onError("No Data Found");
        return;
      }
      //2. on success, create a new post with matching settings
      CreateBlogPost(
        context,
        (createdData: any) => {
          //3. on success, get the id and save the content from the original data

          let newPostId = createdData?.data?.data?.id;

          if (!newPostId) {
            onError("No Post ID Found");
            return;
          }

          SaveBlogPostContent(
            context,
            newPostId,
            blogData.content,
            (data: any) => {
              //return a new object with the copied information
              let newData = { ...blogData };
              newData.id = newPostId;
              newData.publishDate = null;
              newData.status = 1;
              newData.title = newName ;
              newData.URLslug = newData.title.replaceAll(" ", "-");
              onComplete(newData);
            },
            (data: any) => {
              onError(data);
              return;
            }
          );
        },
        (data: any) => {
          onError(data);
        },
        newName,
        "",
        blogData.author,
        blogData.category,
        blogData.tag,
        blogData.imageURL,
        1
      ); // set status to draft
    },
    (data: any) => {
      onError(data);
    }
  );
}

export async function GetPublicBlogPosts(context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void,
    cats:string[]= [],tags:string[] = [],Authors:string[] = []){

    await ValidateToken(context);

    const body = {
        "Category":cats,
        "Tag":tags,
        "Author":Authors,
        IsPublish:true,
    }

    const url = BlogAPIEnum.getPublicPosts;

    await AjPost(url,body,context,onComplete,onError);

}

export async function GetPublicBlogPostsFromTagOrCat(isTag:boolean,context:UserContext,tagOrCatName:string,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await ValidateToken(context);

    let url = (isTag?BlogAPIEnum.getBlogFromTag:BlogAPIEnum.getBlogFromCategory)+tagOrCatName;

    await AjGet(url,context,onComplete,onError);

}

export async function GetAllBlogPosts(context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void,
    cats:string[]= [],tags:string[] = [],Authors:string[] = []){

    await ValidateToken(context);

    const body = {
        "Category":cats,
        "Tag":tags,
        "Author":Authors,
        IsPublish:false,
    }

    const url = BlogAPIEnum.getPublicPosts;

    await AjPost(url,body,context,onComplete,onError);

}

const AuthorCache = {prevResponse:null}

export async function GetBlogAuthors(context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void){

    if(AuthorCache.prevResponse){
        onComplete(AuthorCache.prevResponse);
        return;
    }   

    await ValidateToken(context);

    const onDone = (data:any)=>{

        AuthorCache.prevResponse = data;
        onComplete(data);
    }


    const url = BlogAPIEnum.getAuthors;

    await AjGet(url,context,onDone,onError);

}

export async function EditPostSettings(context:UserContext,postId:string,info:BlogPostInfo,onComplete:(data:any)=>void,onError:(data:any)=>void){
    
    if(typeof info.category == "string"){
        info.category = [];
    }

        await ValidateToken(context);
    
        const body:any = {
            "Id":postId,
            "Title":info.title,
            "MetaDescription":info.metaDescription,
            "TitleTag":info.titleTag??info.title,
            "URLslug": info.slug??info.title.replaceAll(" ","-").toLowerCase(),
            "Author" : info.encAuthor,
            "Category" : info.category?? [],
            "Tag" : info.tags,
            "ImageURL" : info.image,
            "Status" : info.status,
           
 
        }

        if(info.readTime>0){
            body["ReadTime"] = info.readTime;
        }
    
        const url = BlogAPIEnum.editPostWithoutContent;
    
        await AjPost(url,body,context,onComplete,onError);

}



export async function BlogDetailsConsumer(context:UserContext,postSlug:string,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await ValidateToken(context);

    const url = BlogAPIEnum.consumerDetails+postSlug;

    await AjGet(url,context,onComplete,onError);

}

export async function SaveBlogStyling(context:UserContext,styleString:string,onComplete:(data:any)=>void,onError:(data:any)=>void){
    
        await ValidateToken(context);
    
        const body = {
            "style":styleString
        }
    
        const url = BlogAPIEnum.saveStyling;
    
        await AjPost(url,body,context,onComplete,onError);

}

export async function LoadBlogStyling(context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await ValidateToken(context);

    const url = BlogAPIEnum.getStyling;

    await AjGet(url,context,(data)=>{

        if(data?.data?.data?.style){
            onComplete(data.data.data.style);
        }
        else{
            onComplete("");
        }

    },onError);
}


export async function SaveBlogPostContent(context:UserContext,postId:string,postContent:string,onComplete:(data:any)=>void,onError:(data:any)=>void){
    
        await ValidateToken(context);
    
        const body = {
            "Id":postId,
            "Content":postContent
        }
    
        const url = BlogAPIEnum.savePostContent;
    
        await AjPost(url,body,context,onComplete,onError);
}

export async function PublishBlogPost(context:UserContext,postId:string, post:string,onComplete:(data:any)=>void,onError:(data:any)=>void,schedule:Date|null = null){

    await ValidateToken(context);
    const body = {
        "BlogId":postId,
        "Content":post,
        "ScheduleServiceDate":schedule
    }

    let success = {val:true};
    await ActivateBlogPost(context,postId,(data)=>{
  
    },(data)=>{success.val= false});

    if(!success.val){
        onError("Failed to Activate Post");
        return;
    }
    const url = BlogAPIEnum.publishPost;

    await AjPost(url,body,context,onComplete,onError);


}

export async function DeleteBlogPost(context:UserContext,postId:string,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await ValidateToken(context);
    const url = BlogAPIEnum.deletePost+postId;

    await AjDelete(url,context,onComplete,onError);

}


export async function GetBlogTagsOrCategories(isTag:boolean,context:UserContext,onComplete:(data:any)=>void,onError:(data:any)=>void){

    const url = isTag?BlogAPIEnum.listTags:BlogAPIEnum.listCategories;

    await AjGet(url,context,(data)=>{
        if(data?.data?.data){
            onComplete(data.data.data);
        }
        else{
            onError("No Data Found");
        }

    },onError);

}
/*TAGS AND CATEGORIES*/

export async function AddBlogTagOrCategory(isTag:boolean,context:UserContext,name:string,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await ValidateToken(context);
    let body = JSON.stringify( {
        "Id": "0",
        "Name": name
    });

    const url = isTag?BlogAPIEnum.addTag:BlogAPIEnum.addCategory;
    
    await AjPost(url,body,context,onComplete,onError);

}

export async function DeleteBlogTagOrCategory(isTag:boolean,context:UserContext,id:string,onComplete:(data:any)=>void,onError:(data:any)=>void){


    const url = isTag?BlogAPIEnum.deleteTag:BlogAPIEnum.deleteCategory;
    
    await AjDelete(url+id,context,onComplete,onError);

}

export async function LoadBlogEditorDetails(context:UserContext,postId:string,onComplete:(data:any)=>void,onError:(data:any)=>void,mapChipsToStrings:boolean = false){

    await ValidateToken(context);

    const url = BlogAPIEnum.blogEditorDetails+postId;


    await AjGet(url,context,(data)=>{

        if(mapChipsToStrings){
       
            let result = data?.data?.data;

            if(!result){
           
                return;
            }



            GetBlogTagsOrCategories(true,context,(tags:{name:string,id:string}[])=>{
             
                if(result.tag)
                    result.tag = result.tag.map((tagId:string)=>{
                        let tag = tags.find((t)=>t.id == tagId);
                        return tag?tag.name:tagId;
                    });
                GetBlogTagsOrCategories(false,context,(cats:{name:string,id:string}[])=>{

              
                
                    if(result.category)
                        result.category = result.category.map((tagId:string)=>{
                            let tag = cats.find((t)=>t.id == tagId);
                            return tag?tag.name:tagId;
                        });

                    onComplete(data);

                },onError);

            },onError);
        }
        else
            onComplete(data);
    },onError);

}





export async function EditBlogCategory(context:UserContext,category:string,onComplete:(data:any)=>void,onError:(data:any)=>void){

}

export async function DeleteBlogCategory(context:UserContext,category:string,onComplete:(data:any)=>void,onError:(data:any)=>void){

}


export async function UpdateCategoryByPost(context:UserContext,postId:string,category:string[],onComplete:(data:any)=>void,onError:(data:any)=>void){

    const body = {
        "Id":postId,
        "Category":category
    }


}

export async function UpdateTagsByPost(context:UserContext,postId:string,tags:string[],onComplete:(data:any)=>void,onError:(data:any)=>void){

    const body = {
        "Id":postId,
        "Tag":tags
    }


}

export enum BlogPostStatus{
    Draft = 1,
    Published = 2,

}

export function GetPostStatusString(info:BlogPostInfo):{name:string,color:string}{


    if(info.isArchive){
        return {name:"Archived",color:"#BA413E"};
    }

    if(info.status == BlogPostStatus.Published){


        if(info.publishDate && new Date(info.publishDate) > new Date()){


            return {name:"Scheduled",color:"#d48e0d"};
        }
    }
    // else if(info.status == BlogPostStatus.Draft && info.publishDate){

    //     return {name:"Archived",color:"brown"};
    // }

        switch(info.status){
            case BlogPostStatus.Draft: return {name:"Draft",color:"#666"};
            case BlogPostStatus.Published: return  {name:"Published",color:"#3e8b3e"};
            default: return {name:"Unknown",color:"gray"};;
        }

}

export type BlogPostInfo = {
    id:string,
    title:string,
    titleTag?:string,
    content:string,
    readTime:number,
    date:string,
    author:string,
    autorImage?:string,
    category:string[],
    tags:string[],
    status:number,
    metaDescription?:string,
    image:string,
    encAuthor?:string,
    isArchive?:boolean,
    // lastModified:Date,
    publishDate:Date|undefined,
    publishDateStr?:string,
    slug:string
}

export function CreateGenericPost():BlogPostInfo{

  return {
    id: "",
    title: "Untitled Post",
    content: "",
    readTime: 0,
    date: new Date().toISOString().split("T")[0], // e.g., "2024-10-29"
    author: "Anonymous",
    category: [],
    tags: [],
    status:BlogPostStatus.Draft,
    image: "",
    // lastModified: new Date(),
    publishDate: new Date(),
    slug:""
  };
}


export function GenerateRandomPosts(amount:number):BlogPostInfo[]{

    const Titles = ["Test Tile","Blog Post A","Some Title I Guess","Another One","How to Make a Post","Some Really Long Title For Testing Wrapping and Different Space Issues. It's even two sentences long."];
    const Authors = ["Sam H","John Doe","Jane Doe","Some Person","Another Person"];
    const Dates =["Jan 1, 2024","Feb 2, 2024","Mar 3, 2024","Apr 4, 2024","May 5, 2024"];
    const Statuses = ["Draft","Published","Scheduled"];
    const Categories = ["Health","Beauty","Fitness","Wellness"];
    const Tags = ["Popular","Featured","New"];
    const Images = [
        "",
        "https://images.unsplash.com/photo-1721265576553-e7f8242fc915?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1721265250424-a2ad2f1efcf1?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1721143571164-06550363f6d0?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1721162720740-cdc684dc8eea?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://plus.unsplash.com/premium_photo-1721143362795-90becc563ecc?q=80&w=2012&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1602524817552-1afd1d923ace?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1721162720740-cdc684dc8eea?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1721265576553-e7f8242fc915?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://plus.unsplash.com/premium_photo-1720760946714-518ebe939591?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"



    ]
    let posts:BlogPostInfo[] = [];
    for(let i = 0; i < amount; i++){

        let title = Titles[Math.floor(Math.random()*Titles.length)];
        let author = Authors[Math.floor(Math.random()*Authors.length)];
        let date = Dates[Math.floor(Math.random()*Dates.length)];
        let status = 1;
        let image = Images[Math.floor(Math.random()*Images.length)];
        let tagCount = Math.floor(Math.random()*3);
        let tags:string[] = [];
        for(let j = 0; j < tagCount; j++){
           let t = Tags[Math.floor(Math.random()*Tags.length)];
           if(!tags.includes(t)){
                tags.push(t);
           }
        }

        tags = tags.sort((a,b)=>a.localeCompare(b));

        let post = {
            id:i.toString(),
            content:"",
            title,
            author,
            date,
            category:[Categories[Math.floor(Math.random()*Categories.length)]],
            status,
            tags,
            image,
            readTime:0,
            lastModified:new Date(),
            publishDate:new Date(),
            slug:title.replaceAll(" ","-")

        }
   
        posts.push(post);

    }




 
    return posts;
}


export async function PublishBlogStyle(userContext:UserContext,styleString:string,onComplete:(data:any)=>void,onError:(data:any)=>void){

    await ValidateToken(userContext);

    let body = {
        style:styleString
    }

    const url = BlogAPIEnum.publishStyling;
    await AjPost(url,JSON.stringify(body),userContext,onComplete,onError);

    

}